import React, { FC, useEffect } from 'react';

import stylesCss from './assets/dashboard.module.scss';
import InfoCard from 'src/components/InfoCard';
import AdminLayout from 'src/components/layout/RoleLayout';

import classNames from 'classnames';
import Loader from '../../../../components/Loader';

export interface StateProps {
    dashBoardData: InfoObjectLink[];
    inProgress: boolean;
}

export interface DispatchProps {
    getDashboardData: () => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const Dashboard: FC<Props> = (props: Props) => {
    const { dashBoardData, getDashboardData } = props;
    useEffect(() => {
        getDashboardData();
        // eslint-disable-next-line
    }, []);
    dashBoardData.sort((a, b) => a.order - b.order);

    return (
        <AdminLayout>
            <div className={classNames(stylesCss.pageDashboard)}>
                {props.inProgress ? <Loader /> : null}
                <div>
                    <div className={classNames(stylesCss.header, 'pageHeading')}>
                        <h2 className={`${'pageHeadingTitle'}`}>DASHBOARD</h2>
                    </div>
                    <div className={classNames(stylesCss.flexItems)}>
                        {dashBoardData.map((item: InfoObjectLink, k) => (
                            <div
                                key={`${k}info-card`}
                                className={classNames(stylesCss.flexItem, `${stylesCss[item.id]}`)}
                            >
                                <InfoCard {...item} k={`${stylesCss[item.id + 'Icon']}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default Dashboard;
